import React, { PropTypes } from 'react';
import { Dialog, FontIcon, TextField, Checkbox, Avatar } from 'material-ui';
import TCDatePicker from '../../../../tc-ui/date-picker';
import R from 'ramda';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import OpenInNew from 'material-ui/svg-icons/action/open-in-new';
require('../../../../../../less/main.less'); // FOR STORYBOOK
const propTypes = {
  open: PropTypes.bool,
  closeResendContractDialog: PropTypes.func,
  BCCToSelf: PropTypes.bool,
  includeNotes: PropTypes.bool,
  companyName: PropTypes.string,
  companyProfileImage: PropTypes.string,
  customizedMessage: PropTypes.string,
  companyType: PropTypes.string,
  email: PropTypes.string,
  finishedSendingEmail: PropTypes.bool,
  updateProps: PropTypes.func,
  dispatchResendContract: PropTypes.func,
  onBCCSelfCheck: PropTypes.func,
  submissionCriteria: PropTypes.string,
  loading: PropTypes.bool,
  isExternal: PropTypes.bool,
  editEmail: PropTypes.bool,
  newEmail: PropTypes.string,
  updatePartnerForAllContracts: PropTypes.bool,
  doNotSendEmail: PropTypes.bool,
  updatePartnerForSentDoc: PropTypes.func,
  newPartnerName: PropTypes.string,
  changesSaved: PropTypes.bool,
  resendToEmails: PropTypes.array,
  to: PropTypes.object,
  toEmails: PropTypes.array,
  partner: PropTypes.object,
  subject: PropTypes.string,
  deadlineDate: PropTypes.string,
};
const ResendContractComponent = props => {
  const {
    open,
    closeResendContractDialog,
    loading,
    subject,
    customizedMessage,
    finishedSendingEmail,
    updateProps,
    dispatchResendContract,
    resendToEmails,
    changesSaved,
    deadlineDate,
    partner = {},
  } = props;
  const isSupplier = props.companyType === 'Supplier';
  const onCheckAContact = email => (_, checked) => {
    if (checked) {
      updateProps({
        resendToEmails: [...resendToEmails, email],
      });
    } else {
      updateProps({
        resendToEmails: resendToEmails.filter(x => x !== email),
      });
    }
  };
  const onChangeDeadlineDate = date => updateProps({ deadlineDate: date });
  const onChangeSubject = e => {
    updateProps({ subject: e.target.value });
  };
  return (
    <Dialog
      contentStyle={{ width: '700px' }}
      autoScrollBodyContent
      title={`${changesSaved ? 'Send' : 'Resend'} Email for this ${
        isSupplier ? 'Contract' : 'Request'
      }`}
      titleStyle={{ backgroundColor: '#00BCD4', color: '#ffffff', fontSize: '18px', padding: '2%' }}
      open={open}
      actions={[
        <FlatButton
          loader={loading}
          label={finishedSendingEmail ? 'Close' : 'Cancel'}
          primary
          onTouchTap={closeResendContractDialog}
        />,
        <FlatButton
          loader={loading}
          label="Resend"
          secondary
          onTouchTap={dispatchResendContract}
          disabled={finishedSendingEmail || loading || !customizedMessage || !subject}
        />,
      ]}
    >
      {
        finishedSendingEmail
        ? (
            <div style={{ marginTop: '20px' }}>
              Congratulations, your {isSupplier ? 'contract' : 'request'} has been sent!
            </div>
          )
        : (
          <div>
            <div style={{ margin: '12px 0px 4px', display: 'flex', alignItems: 'center' }}>
              <div style={{ fontSize: '16px' }}>Partner: {partner.name}</div>
              <OpenInNew
                style={{ color: 'rgba(0, 0, 0, 0.54)', height: '22px', width: '22px', cursor: 'pointer', marginLeft: '16px' }}
                onClick={() => window.open(`${process.env.NEW_SYSTEM_URL}/partner-management/partner-details/${
                  partner.id
                }?jwt=${localStorage.getItem('jwt')}`)}
              />
            </div>
            <div style={{ width: '100%', fontSize: '13px' }}>
              {(partner.contacts || []).map(({ id, email }) => (
                <Checkbox
                  key={id}
                  label={email}
                  checked={resendToEmails.indexOf(email) > -1}
                  onCheck={onCheckAContact(email)}
                />
              ))}
            </div>
            {!finishedSendingEmail && (
              <div>
                {
                  !isSupplier && (
                    <div>
                      <TCDatePicker
                        textFieldStyle={{ display: 'inline-block', width: '90%' }}
                        containerStyle={{ display: 'inline-block', marginTop: '1em' }}
                        value={deadlineDate}
                        initialMonth={deadlineDate || new Date()}
                        onChange={onChangeDeadlineDate}
                        floatingLabelText="Deadline Date"
                        closeOnSelect
                      />
                    </div>
                  )
                }
                <div>
                  <label>Subject:</label>
                  <br/>
                  <input
                    value={subject || ''}
                    style={{ width: '100%' }}
                    onChange={onChangeSubject}
                  />
                </div>
                <label>Message:</label>
                <div
                  style={{
                    padding: '8px 12px',
                    overflow: 'auto',
                    minHeight: '80px',
                    border: '1px solid #00BCD4',
                    margin: '12px 0',
                  }}
                >
                  <FontIcon className="tc-icon-email" color="#bfbfbf" style={{ top: '12px' }} />
                  <TextField
                    id="commentBoxTextField"
                    hintStyle={{ fontSize: '14px' }}
                    underlineShow={false}
                    defaultValue={customizedMessage}
                    onChange={({ target: { value } }) => updateProps({ customizedMessage: value })}
                    style={{ float: 'right', width: '85%', marginRight: '5%' }}
                    multiLine
                    rowsMax={5}
                  />
                </div>
              </div>
            )}
          </div>
        )
      }
    </Dialog>
  );
};

ResendContractComponent.propTypes = propTypes;
export default ResendContractComponent;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/dialogs/ResendContract.jsx